import React, { useEffect, useRef } from 'react';
import ElbetLogoLoader from '../svg/elbet-logo-loader';
import { getGameName, isSoaringGame } from '../../services/RocketmanTransport';
import SoaringLogoLoader from '../svg/soaring-logo-loader-svg';
import { formatGameName } from '../../services/Helpers/StringHelper';

export default function RocketmanSlider() {
  const titleRef = useRef(null);

  useEffect(() => {
    if (isSoaringGame && getGameName && titleRef.current) {
      const el = titleRef.current;
      const name = formatGameName(getGameName.toString().replace(/_/g, " "));

      // Handle underscores: break into multiple lines if long
      let formatted = name;
      if (name.length > 12 && name.includes('_')) {
        formatted = name.replace(/_/g, '\n');
      } else {
        formatted = name.replace(/_/g, ' ');
      }
      el.textContent = formatted;

      // Adjust font size dynamically (relative scaling)
      let scale = 1;
      if (name.length > 16) scale = 0.6;
      else if (name.length > 14) scale = 0.65;
      else if (name.length > 12) scale = 0.75;
      else if (name.length > 8) scale = 0.8;

      el.style.transform = `scale(${scale})`;
      el.style.transformOrigin = 'center center';
    }
  }, []);

  if (!getGameName) {
    return (
      <div className="slide rocketman-slide">
        {isSoaringGame ? (
          <SoaringLogoLoader />
        ) : (
          <ElbetLogoLoader width={192} height={190} />
        )}
        {isSoaringGame ? '' : <p>Rocketman</p>}
      </div>
    );
  } else {
    return (
      <div className="slide rocketman-slide">
        {isSoaringGame ? (
          <div ref={titleRef} className="game-name-soaring"></div>
        ) : (
          <ElbetLogoLoader
            width={192}
            height={190}
            gameName={getGameName}
          />
        )}
      </div>
    );
  }
}
